import { render, staticRenderFns } from "./SPRNativeLanguageSelector.vue?vue&type=template&id=387806dc&scoped=true"
import script from "./SPRNativeLanguageSelector.vue?vue&type=script&lang=js"
export * from "./SPRNativeLanguageSelector.vue?vue&type=script&lang=js"
import style0 from "./SPRNativeLanguageSelector.vue?vue&type=style&index=0&id=387806dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387806dc",
  null
  
)

export default component.exports